/**
 * Seiten, die es nur auf Deutsch gibt (QUAWEB-40, Entscheid Jan 15.10.2026).
 *
 * Drei Stellen lesen diese Liste:
 *
 * - `ssg-routes.ts` baut fuer sie keinen EN-Zwilling. Ein Zwilling ohne Route
 *   waere ein Soft-404, und `validate-ssg-routes.ts` bricht `pnpm dist` dann
 *   mit Exit 1 ab (nachgemessen 1.9.2026).
 * - `LanguageSwitcher` fuehrt von ihnen auf `/en/`. Uebersetzt ergaebe der Pfad
 *   eine 404: `ki-potenzialanalyse` hat einen EN-Slug, die Seite aber keine
 *   EN-Fassung (`/en/campaign/ai-potential-analysis`).
 * - `useHead` gibt fuer sie kein `hreflang="en"` aus.
 *
 * **Kein Import aus `.velite`.** `LanguageSwitcher` und `useHead` laden das
 * Modul im Client; `ssg-routes.ts` importiert `.velite` und taugt dafuer nicht.
 *
 * Jeder Pfad steht auch in `NUR_DE_ERLAUBT` (`App.routes.spec.ts`); der Fall
 * dort haelt beide Listen deckungsgleich. Die Pfade sind DE-kanonisch und ohne
 * abschliessenden Schraegstrich.
 */
export const GERMAN_ONLY_PATHS: readonly string[] = [
    // Kampagnen-Landeseiten ohne EN-Fassung (Plan 2026-10-15-kampagnenseiten.md).
    "/kampagne/ki-potenzialanalyse",
    "/kampagne/systemintegration",
];

/** `true`, wenn `pathname` eine reine DE-Seite ist; der Schraegstrich am Ende zaehlt nicht. */
export const isGermanOnlyPath = (pathname: string): boolean => {
    const ohneSchraegstrich = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
    return GERMAN_ONLY_PATHS.includes(ohneSchraegstrich);
};
